"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tracker = void 0;
class Tracker {
    constructor(config, objectKeyFormatter = null) {
        this.config = {};
        this.objectKeyFormatter = null;
        this.updateConfig = (config) => {
            this.config = config;
        };
        this.track = (action, data) => {
            const information = this.getInformation(action, data);
            if (information) {
                this.sendInfo(information);
            }
        };
        this.objectKeyFormatter = objectKeyFormatter;
        this.config = config;
    }
    parseData(data) {
        return this.objectKeyFormatter ? this.objectKeyFormatter(data) : data;
    }
    getActions(action) {
        const actions = this.config[action];
        if (!actions) {
            return undefined;
        }
        return actions;
    }
    getConfigByFunction(actions, data) {
        if (typeof actions === 'function') {
            return actions(data);
        }
        return undefined;
    }
    getConfigByAction(action) {
        return Object.assign({}, this.config[action]);
    }
    getInformation(action, data) {
        const actions = this.getActions(action);
        if (actions) {
            const configByFunction = this.getConfigByFunction(actions, data);
            return configByFunction || this.getConfigByAction(action);
        }
        return undefined;
    }
}
exports.Tracker = Tracker;
//# sourceMappingURL=tracker.js.map